const categories = {
    Agriculture: [
        "Happy when visiting farm",
        "Have agriculture background",
        "Happy to visit farm land",
        "Fulfilled when visiting farm",
        "Love to cultivate flowers",
        "Love to grow flowers",
        "To create agricultural revolution",
        "Increase farm's production"
    ],
    "Dairy & Animals": [
        "To start business in fishing",
        "Have fishing background",
        "Want to conserve and save fishes",
        "To study about fishes",
        "Milk based food business",
        "New technology in milk production",
        "Rubber tech",
        "Rubber business",
        "To start Organic food business"
    ],
    Finance: [
        "Excellent in mathematics",
        "Good at managing money and spending",
        "Prepare budget for family",
        "Good at accounting",
        "Good at budgeting",
        "Analytical skill",
        "You feel stock market is exciting",
        "Good at investing in stock market",
        "Love interacting with people",
        "Secure job"
    ],
    "History & Language": [
        "Exploring different language and culture",
        "To discover new facts about dinosaurs",
        "Finding how language developed",
        "Evolution of human beings",
        "Good at learning new language",
        "Interested in learning history",
        "Travel to historical places",
        "To learn how culture developed",
        "New ideas about evolution",
        "Truth of ancient life",
        "Exploring origin of different cultures in world",
        "Discover our past"
    ],
    Media: [
        "Excellent writing skills",
        "Want interesting job & life",
        "To reveal a crime",
        "To uplift public through information",
        "Show the true world by photography",
        "Photography is my world"
    ],
    Advertisement: [
        "Excellent communication",
        "Meme or logo designer",
        "Good at interacting with people",
        "Good at creating memes and digital content",
        "Understanding current trend",
        "Very talented in Ad-zap",
        "Created many concepts for Ad-Zap"
    ],
    Teaching: [
        "Feel good to be around kids",
        "Want to help special kids",
        "Got appreciated for taking seminars",
        "You explain concepts to friends before exam"
    ],
    Beautician: [
        "Appreciated for good make up sense",
        "Want to be self-employed",
        "Good at suggesting hair-styles",
        "Watch make up videos in social media",
        "Friends ask you for beauty tips",
        "Love good Fragrance",
        "Good taste in picking perfumes",
        "To create best perfumes",
        "Good in chemistry"
    ],
    Food: [
        "Appreciated for best cooking",
        "Appreciated for making best cake at home",
        "Bake good cakes at home",
        "Love cooking for everyone",
        "Experimented new recipes",
        "Created new recipes",
        "You suggest diet plans",
        "Your diet plan works",
        "Interested in finding best food",
        "To increase fitness culture",
        "To start a fitness culture",
        "Friends come to you for restaurants suggestion",
        "You know where to get good food",
        "Suggest restaurants to friends",
        "Love chocolate",
        "Add more flavor to food",
        "You guess the flavor of food",
        "To make food more tastier",
        "Create new recipes with chocolate"
    ],
    "Travel & Tourism": [
        "Adventurous life",
        "To feel Adrenaline rush",
        "Love travelling",
        "Excellent communication",
        "Unique career",
        "Want a different life",
        "Good at planning tour with budget",
        "Involved in planning tour",
        "Watch videos on history",
        "Interested in finding history"
    ],
    Aviation: [
        "Fascinated by flying machines",
        "Dream to fly a fighter Jet",
        "To Serve our nation",
        "Want prestigious job",
        "Have good reflex",
        "Love to design & construct planes",
        "Excellent Communication"
    ],
    Photography: [
        "Feel good when taking photos",
        "Feel happy to capture wildlife",
        "Got appreciated for photography skills",
        "Love to explore nature",
        "Finding beauty in everything you see",
        "Capture rare wildlife events",
        "To convey a message through photos",
        "You see this world through camera"
    ],
    Biology: [
        "To protect environment",
        "To create new medicines from plant",
        "To Study about animals life",
        "Feel happy to interact with animals",
        "Develop vaccines through microbes",
        "Develop vaccines against pandemic diseases like COVID",
        "Vaccines for Harmful viruses",
        "Love nature",
        "Curious about life of microbes",
        "Love to travel in ocean",
        "Interested in life of plants & animals in ocean",
        "Find new species in ocean"
    ],
    Fashion: [
        "Have photogenic face",
        "Friends call you a poser",
        "You never run out of poses",
        "Got compliments for stylish walk",
        "Unique personality",
        "Excellent communication",
        "Charming Look",
        "Drew costumes during class-hours",
        "Drew costumes during free time",
        "Always in search of new costume",
        "Your dressing stands out from crowd",
        "Suggest dresses for friends and family",
        "Made my Friend's dressing better",
        "Prepared your friend for interview",
        "Made your friends speak professionally",
        "Suggested dresses for business events"
    ],
    "Merchant Navy": [
        "To serve our nation",
        "Love ships & to sail",
        "Passion for Indian Navy",
        "Sailing makes you happy",
        "Adventurous life",
        "Meet new people",
        "Visit exotic and new places",
        "Fascinated to work on a ship",
        "Curious on how ships work"
    ],
    "Building and Construction": [
        "Appreciated for decorating your home",
        "Have different ideas to make home beautiful",
        "Good or excellent at Art",
        "Love and admire monuments",
        "Curious on how monuments are built",
        "Visualize decorations for home",
        "Interested in real estate",
        "Can persuade people to buy",
        "Build beautiful structures",
        "Want to build better roads",
        "Good at convincing",
        "Fascinated by tall structures",
        "Make buildings more safe",
        "Make buildings more strong",
        "Build pleasing structures"
    ],
    "Energy & Electricity": [
        "Assembled computer by yourself",
        "Develop new communication equipment",
        "Develop military equipments",
        "Good at circuits design at class 10",
        "New electric equipments",
        "Enhance electric power",
        "Use nuclear technology for energy",
        "Interested in nuclear experiments",
        "Sustainable energy through nuclear technology",
        "Interested in Nuclear physics",
        "Love Physics"
    ],
    Technology: [
        "Curious about photonic Technology",
        "Futuristic Technologies",
        "Curious about Nano technology",
        "Solve problems with Nano Technology",
        "Start a revolution in Heath, Science & Technology",
        "Application in navigation of missiles",
        "Improve communication technology",
        "Make works easy by automation",
        "Interested in Robotics",
        "Make our life easy by robotics"
    ],
    "Mechanical & Industrial": [
        "Drew cars & bikes design during class",
        "New ideas for cars & bikes",
        "Crazy about cars & Bikes",
        "Read only about cars & bikes",
        "Find Solution with mechanical devices",
        "Interested in mechanical devices",
        "Interested in how metals created",
        "New ideas to extract metal from ore",
        "Make materials that are useful to human",
        "Make new element",
        "Want to work in different industries",
        "You can make things work better",
        "Improve a company's performance",
        "Good at creative solutions",
        "Develop new devices",
        "Maintain manufacturing equipment",
        "Re-design existing devices",
        "Handle heat to produce energy"
    ],
    Music: [
        "Got Appreciated for singing",
        "To Entertain others with music"
    ],
    Cinema: [
        "Done plays at school",
        "Good at Mono-acting",
        "In Mono-acting team",
        "Written plays at school",
        "You write interesting short stories",
        "Good at narrating any funny or interesting stories",
        "Visualize or imagine stories",
        "Imagine and create stories",
        "Love watching world cinema",
        "Tiktoker",
        "Strong social media presence",
        "Appreciation for excellent reels",
        "Edited friend's short film",
        "Love editing videos",
        "Appreciated for video editing"
    ],
    Entertainment: [
        "Spontaneous speaker",
        "Charming speaker",
        "Excellent communication skills",
        "Anchored cultural events in schools/colleges",
        "Everyone enjoyed your anchoring",
        "Unique style of communication",
        "Have pleasant voice",
        "Dance is your love",
        "Dancing makes you happy",
        "Dance takes away stress",
        "Choreographed in school competition",
        "Appreciated for unique dance"
    ],
    Jewelry: [
        "Already in jewelry business",
        "Fascinated by diamonds",
        "Made awesome jewelry in craft class",
        "Have new ideas for jewelry",
        "Good at Art",
        "Interested in Gems"
    ],
    Fitness: [
        "Dream to make everyone fit",
        "Bodybuilding is your passion",
        "Going to gym everyday feels happy"
    ],
    Politics: [
        "To help our people",
        "To help and uplift poor people",
        "Serve our country",
        "To Develop our nation",
        "To become representative of people",
        "To create a change"
    ],
    Astronomy: [
        "Are we alone in this universe?",
        "Curious about space",
        "Find life on another planet",
        "Study about stars",
        "Always dreamt of flying beyond sky"
    ],
    "Typing & Writing": [
        "Want a part time job",
        "Appreciated in creative writing"
    ],
    "Environment & Natural Resources": [
        "To protect environment",
        "Save earth from climate change",
        "Love to study about Oceans",
        "Explore and discover natural resources",
        "Explore & produce oil and Gas",
        "Provide energy and also protect environment",
        "Protect life from risk of fire",
        "To improve fire safety"
    ],
    "Computer Science": [
        "Want to know how games are developed",
        "Innovative in programming class",
        "Very good at computer language",
        "Good at deciding computer security",
        "Appreciated for coding in programming class",
        "Curious about computer language",
        "Want to Create smart and automatic devices",
        "Ethical hacking is interesting",
        "Assembled computer",
        "You learn computer language quickly",
        "Develop new technologies",
        "To Manage data online"
    ],
    "Management & Administration": [
        "Very good at planning",
        "Organized cultural event at school",
        "Dream of starting a business",
        "Ready to take responsibility",
        "To develop or uplift rural people",
        "Create safety in industrial areas",
        "Good at handling people",
        "Identify talent of your friends",
        "Want to meet new people",
        "Excellent communication skill",
        "Already in hotel business",
        "Good at multitasking",
        "Good at preparing budget",
        "Easily identify quality products",
        "Find defective products when shopping"
    ],
    "Exotic & Unique Career": [
        "Unique career options",
        "Want to stand out from crowd",
        "Good at managing events",
        "Managed cultural events",
        "Plan birthday parties",
        "Organize birthday parties and surprises",
        "Interesting careers",
        "Love pubs and parties",
        "Love pets",
        "Interested in wine and its taste",
        "Loved toys"
    ],
    Army: [
        "Save our nation",
        "Passion for Indian Army",
        "Love our country",
        "To protect and serve our nation"
    ],
    "Logistics & SCM": [
        "Already in retail business",
        "Very organized person",
        "Good at planning & executing",
        "Like planning and executing",
        "Want to improve performance of organization",
        "Interested in product and services delivery"
    ],
    Painting: [
        "Appreciated for artistic skills",
        "Draw pictures during classes",
        "Talented in painting and drawing",
        "Love to draw or paint"
    ],
    Investigation: [
        "Want adventurous career",
        "Admire police officers",
        "Protect & help public",
        "Want a prestigious job",
        "Want Government job",
        "You can do clear background checks",
        "You get information about a person quickly"
    ],
    "Statistics & Actuaries": [
        "Strong Mathematical ability",
        "Make predictions using data",
        "Understand the world using research",
        "Find new information",
        "Help organization to make decisions",
        "Determine future events",
        "Analyze & understand risk",
        "Create best insurance policy"
    ],
    Sports: [
        "Explore under water",
        "Energetic in sport activities",
        "Love adrenaline rush",
        "Want Adventurous life",
        "Want unique life and career",
        "Love to meet new people",
        "Love nature",
        "Have risk taking ability",
        "Maintain physical fitness",
        "Happy to travel into ocean",
        "You love sports",
        "Passion for sports",
        "Best in cricket",
        "Best in any game",
        "Appreciated for unique strategy in sports",
        "Appreciated when playing any sports",
        "Considered as best in sports"
    ]
}

export default categories;